export * from './core/state_memento';

export * from './engine/orm';

export * from './types/relationship';
export * from './types/datasource';
export * from './types/metasource';
export * from './types/usersource';
export * from './types/command';
export * from './types/query';
export * from './types/model';

import { ORM } from './engine/orm';

/**
 * @deprecated used to support older code and transition away from QueryMediator
 */
export const ORMMediator = ORM;



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-orm/dist/main.ts